'use client'
import React from 'react'

const Gallery = () => {
    return (
        <>
            <section id="gallery" class="our-gallery">
                <div class="row">
                    <h2 class="heading-title">Our Gallery</h2>
                    <div id="tab-1" class="tab-content current">
                        <div class="tab-col">
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="images/galley-images/gallery-img1-big.jpg" title=""><img src="images/galley-images/gallery-img1.jpg" alt="" /></a>
                            </div>
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="images/galley-images/gallery-img4-big.jpg" title=""><img src="images/galley-images/gallery-img4.jpg" alt="" /></a>
                            </div>
                        </div>
                        <div class="tab-col">
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="images/galley-images/gallery-img2-big.jpg" title=""><img src="images/galley-images/gallery-img2.jpg" alt="" /></a>
                            </div>
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="images/galley-images/gallery-img6-big.jpg" title=""><img src="images/galley-images/gallery-img6.jpg" alt="" /></a>
                            </div>
                        </div>
                        <div class="tab-col">
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="images/galley-images/gallery-img3-big.jpg" title=""><img src="images/galley-images/gallery-img3.jpg" alt="" /></a>
                            </div>
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="images/galley-images/gallery-img7-big.jpg" title=""><img src="images/galley-images/gallery-img7.jpg" alt="" /></a>
                            </div>
                        </div>
                        <div class="tab-col">
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="images/galley-images/gallery-img5-big.jpg" title=""><img src="images/galley-images/gallery-img5.jpg" alt="" /></a>
                            </div>
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="images/galley-images/gallery-img4-big.jpg" title=""><img src="images/galley-images/gallery-img4.jpg" alt="" /></a>
                            </div>
                        </div>
                    </div>
                    <div id="tab-2" class="tab-content">
                        <div class="tab-col">
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="images/galley-images/gallery-img4-big.jpg" title=""><img src="images/galley-images/gallery-img4.jpg" alt="" /></a>
                            </div>
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="/images/galley-images/gallery-img5-big.jpg" title=""><img src="images/galley-images/gallery-img5.jpg" alt="" /></a>
                            </div>
                        </div>
                        <div class="tab-col">
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="/images/galley-images/gallery-img2-big.jpg" title=""><img src="images/galley-images/gallery-img2.jpg" alt="" /></a>
                            </div>
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="/images/galley-images/gallery-img6-big.jpg" title=""><img src="images/galley-images/gallery-img6.jpg" alt="" /></a>
                            </div>
                        </div>
                        <div class="tab-col">
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="images/galley-images/gallery-img3-big.jpg" title=""><img src="images/galley-images/gallery-img3.jpg" alt="" /></a>
                            </div>
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="/images/galley-images/gallery-img1-big.jpg" title=""><img src="images/galley-images/gallery-img1.jpg" alt="" /></a>
                            </div>
                        </div>
                        <div class="tab-col">
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="/images/galley-images/gallery-img4-big.jpg" title=""><img src="images/galley-images/gallery-img4.jpg" alt="" /></a>
                            </div>
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="/images/galley-images/gallery-img5-big.jpg" title=""><img src="images/galley-images/gallery-img5.jpg" alt="" /></a>
                            </div>
                        </div>
                    </div>
                    <div id="tab-3" class="tab-content">
                        <div class="tab-col">
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="/images/galley-images/gallery-img2-big.jpg" title=""><img src="images/galley-images/gallery-img2.jpg" alt="" /></a>
                            </div>
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="/images/galley-images/gallery-img6-big.jpg" title=""><img src="images/galley-images/gallery-img6.jpg" alt="" /></a>
                            </div>
                        </div>
                        <div class="tab-col">
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="/images/galley-images/gallery-img3-big.jpg" title=""><img src="images/galley-images/gallery-img3.jpg" alt="" /></a>
                            </div>
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="/images/galley-images/gallery-img4-big.jpg" title=""><img src="images/galley-images/gallery-img4.jpg" alt="" /></a>
                            </div>
                        </div>
                        <div class="tab-col">
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="/images/galley-images/gallery-img5-big.jpg" title=""><img src="images/galley-images/gallery-img5.jpg" alt="" /></a>
                            </div>
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="/images/galley-images/gallery-img6-big.jpg" title=""><img src="images/galley-images/gallery-img6.jpg" alt="" /></a>
                            </div>
                        </div>
                        <div class="tab-col">
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="/images/galley-images/gallery-img2-big.jpg" title=""><img src="images/galley-images/gallery-img2.jpg" alt="" /></a>
                            </div>
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="/images/galley-images/gallery-img6-big.jpg" title=""><img src="images/galley-images/gallery-img6.jpg" alt="" /></a>
                            </div>
                        </div>
                    </div>
                    <div id="tab-4" class="tab-content">
                        <div class="tab-col">
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="/images/galley-images/gallery-img1-big.jpg" title=""><img src="images/galley-images/gallery-img1.jpg" alt="" /></a>
                            </div>
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="/images/galley-images/gallery-img6-big.jpg" title=""><img src="images/galley-images/gallery-img6.jpg" alt="" /></a>
                            </div>
                        </div>
                        <div class="tab-col">
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="images/galley-images/gallery-img3-big.jpg" title=""><img src="images/galley-images/gallery-img3.jpg" alt="" /></a>
                            </div>
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="images/galley-images/gallery-img4-big.jpg" title=""><img src="images/galley-images/gallery-img4.jpg" alt="" /></a>
                            </div>
                        </div>
                        <div class="tab-col">
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="/images/galley-images/gallery-img2-big.jpg" title=""><img src="images/galley-images/gallery-img2.jpg" alt="" /></a>
                            </div>
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="/images/galley-images/gallery-img5-big.jpg" title=""><img src="images/galley-images/gallery-img5.jpg" alt="" /></a>
                            </div>
                        </div>
                        <div class="tab-col">
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="/images/galley-images/gallery-img7-big.jpg" title=""><img src="images/galley-images/gallery-img7.jpg" alt="" /></a>
                            </div>
                            <div class="gallery-img">
                                <a class="fancybox" data-fancybox-group="gallery1" href="images/galley-images/gallery-img6-big.jpg" title=""><img src="images/galley-images/gallery-img6.jpg" alt="" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Gallery